import { render, staticRenderFns } from "./RevisionSelect.vue?vue&type=template&id=3b5fb089&scoped=true&"
import script from "./RevisionSelect.vue?vue&type=script&lang=js&"
export * from "./RevisionSelect.vue?vue&type=script&lang=js&"
import style0 from "./RevisionSelect.vue?vue&type=style&index=0&id=3b5fb089&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5fb089",
  null
  
)

export default component.exports